import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postInvoices({ body }) {
  return BaseService.post(REST.INVOICES, body);
}

function putInvoices({ body, id }) {
  return BaseService.put(REST.INVOICES_ID(id), body);
}

function getInvoices(params) {
  return BaseService.get(REST.INVOICES, {
    params: paramsFilter({ params }),
  });
}

function downloadInvoices({ params }) {
  return `${process.env.REACT_APP_REST_URL}${REST.INVOICES_EXCEL}?${params}`;
}

function downloadInvoicesDetail({ id }) {
  return `${process.env.REACT_APP_REST_URL}${REST.INVOICES_EXCEL_DETAIL(id)}`;
}

function deleteInvoices({ id }) {
  return BaseService.delete(REST.INVOICES_ID(id));
}

export default {
  deleteInvoices,
  getInvoices,
  putInvoices,
  postInvoices,
  downloadInvoices,
  downloadInvoicesDetail,
};
